const activeTabBackground = "#FFFFFF";
const activeTabAccent = "#15749D";
const activeTabHover = "#B8D5E1";

export const fallbackValues = {
  activeTabBackground,
  activeTabAccent,
  activeTabHover
};
